module.exports = __webpack_public_path__ + "img/transfer-shop-butt.b983148b.png";